module.exports = __webpack_public_path__ + "media/2500-2_YR_2022_FlashDriveAttacks.4282cd2a.mp4";